<script setup lang="ts">
onMounted(() => navigateTo({ path: "/info/faq/" }));
definePageMeta({ layout: "home" });
</script>

<template>
  <div> Redirecting ...</div>
</template>
